import * as actionTypes from '../actionsTypes';
import axios from '../../../http-config';
import swal from 'sweetalert';

export const fetchAreaListingStart = () => {
    return {
        type: actionTypes.FETCH_AREA_START
    }
}
export const fetchAreaSucces =(response)=>{
    return {
        type : actionTypes.FETCH_AREA_SUCCESS,
        areaListing : response.data.areas,
        totalCount:response.totalCount
    }
}

export const fetchAreaListingFail = (error) => {
    return {
        type: actionTypes.FETCH_AREA_FAIL,
        error:error
    }
}

export const AreaList = (payload)=>{
    let token = localStorage.getItem('token');
    return dispatch=>{
        dispatch(fetchAreaListingStart());
        const url = `/area/?limit=${payload.limit}&page=${payload.page}`
        axios.get(url, {headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(response=>{
            dispatch(fetchAreaSucces(response.data))
        })
        .catch(err=>{
            dispatch(fetchAreaListingFail(err))
        })
    }
}

export const addArea = (payload,props) => {
    let token= payload.token
    let body = {
        "name":payload.name,
        "name_tn":payload.name_tn
    }
    return (dispatch) => {
        const url = '/area/addArea'
        dispatch(fetchAreaListingStart())
        axios.post(url, body, { headers : { "Authorization":`Bearer ${token}`}})
        .then((response) => {
            const fetchedResponse = response.data.success;
            fetchedResponse && swal({
                title: "Area added successfully!",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
            })
            dispatch(AreaList({limit:10,page:1}))
            props.history.push('/area-management')
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
        })
        .catch((err) => {
            dispatch(fetchAreaListingFail(err))
        })
    }
}

export const editArea = (payload,props) => {
    let token= payload.token
    const id = payload.id
    return (dispatch) => {
        const body = {
            Name     : payload.name,
            Name_tn  : payload.name_tn,
        }
        dispatch(fetchAreaListingStart())
        const url = `/area/${id}`
        axios.put(url, body, {headers:{"Authorization":`Bearer ${token}`}})
        .then((response) => {
            const fetchedResponse = response.data.success;
            fetchedResponse && swal({
                title: "You have successfully updated the data!!!",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
            })
            // dispatch(fetchUserListing(token))
            props.history.push('/area-management')
        },
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
        })
        .catch((err) => {
            // dispatch(fetchUserListingFail(err))
        })
    }
}